// export const environment = {
//     production: false,
//     url: "http://eip-api-env.us-east-1.elasticbeanstalk.com/contentprotection/",
//     authKey:"97e7205bc03d1b27361feda89cf750b8ee1587a7",
//     ADKey:"4e45394b-2d16-4268-9a29-4e1828f65688"
//   };
export const environment = {
  production: false,
  url: 'https://contentprotection-dev.paramount.com/contentprotection/',//'http://127.0.0.1:8000/contentprotection/',
  // url:'https://eip-api-anthos.use1.dev.aws.viacbs.cloud/contentprotection/',
  authKey: '317b205008aff6580541ce3094b0d4e7026b3e74',
  premiereDatePatchAPI: 'http://progwebdev01.corp.ad.viacom.com:9002/api/premierepatch/',
  ADKey: '4e45394b-2d16-4268-9a29-4e1828f65688',
  envName: 'dev',//   //OKTA configuration added
  redirectUri: 'http://eip-frontend.use1.dev.aws.viacbs.tech/', //dev;  
  //redirectUri: 'https://eip-dev.viacom.com/',  
  // redirectUri:window.location.origin,//for local
  clientId: '0oa1iyhrvyeKlVn1O1d8',
  issuer: 'https://cbsi.okta.com',
  toolsApi: "https://eip-tools-dev.paramount.com/api/"
};
